export const getCdnUrl = (path: string) => {
  const cdnBase = process.env.NEXT_PUBLIC_CDN_URL || '';
  // Se o path começar com /, removemos para não duplicar na URL final
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  
  // Se não houver CDN configurada (localhost), retorna o path original (relativo)
  if (!cdnBase) {
      return path.startsWith('/') ? path : `/${cleanPath}`;
  }

  return `${cdnBase}/${cleanPath}`;
};
